import {useEffect, useRef} from '@wordpress/element';
import {useApiRequests} from "../../../hooks";

export const useProcessFastlaneToken = (
    {
        token,
        emitResponse,
        onPaymentSetup,
        needsSetupToken,
        shouldSavePayment
    }) => {

    const currentData = useRef({token});

    const {
        createPaymentToken
    } = useApiRequests({
        paymentMethod: 'ppcp_card'
    });

    useEffect(() => {
        currentData.current = {token, emitResponse, shouldSavePayment};
    }, [token, emitResponse, shouldSavePayment]);

    useEffect(() => {
        const unsubscribe = onPaymentSetup(async () => {
            let {
                token,
                emitResponse,
                shouldSavePayment
            } = currentData.current;
            try {
                if (needsSetupToken) {
                    token = await createPaymentToken(token.id, {fastlane: true});
                }

                return {
                    type: emitResponse.responseTypes.SUCCESS,
                    meta: {
                        paymentMethodData: {
                            ppcp_card_payment_token: token.id,
                            ppcp_card_paypal_order_id: '',
                            ppcp_card_save_payment: shouldSavePayment
                        }
                    }
                }
            } catch (error) {
                return {
                    type: emitResponse.responseTypes.ERROR,
                    message: error?.message,
                    messageContext: emitResponse.noticeContexts.PAYMENTS
                }
            }
        });


        return unsubscribe;
    }, [
        onPaymentSetup,
        needsSetupToken,
        createPaymentToken
    ]);
}